import { useTranslation } from 'react-i18next';

import { TavoliMiei } from '@/components/gamehost/TavoliMiei';
import type { EtichetteTavoli, RisultatoTavoli } from '@/components/gamehost/TavoliMiei';
import { scala40Api } from '@/services/limuloScala40';

/** La lettura dei miei tavoli di QUESTO gioco: una funzione di MODULO (stabile) che chiama la sua query RTK, come vuole il contratto di `TavoliMiei` (#747, A3). */
const usaTavoli = (): RisultatoTavoli => scala40Api.useGetMyScala40TablesQuery(undefined, { refetchOnMountOrArgChange: true });

/** La rotta del tavolo della scala 40, dall'uuid minuscolo. */
const rottaTavolo = (tableId: string): string => `/scala40/tavolo/${tableId}`;

/**
 * «I MIEI TAVOLI / RIPRENDI» della scala 40: la lobby COMUNE dei giochi del kit (`components/gamehost/TavoliMiei.tsx`, #747) coi parametri della scala 40 — la sua lettura (`scala40.table.mine.list`), la rotta di
 * «Riprendi» e i testi, GIA tradotti dal SUO catalogo (`scala40:hub.tavoli.*`): il componente comune non ha testi. Il nome del tavolo dice il formato («Scala 40 · 4 posti»).
 */
export function TavoliMieiScala40() {
  const { t } = useTranslation('scala40');
  const etichette: EtichetteTavoli = {
    titolo: t('hub.tavoli.titolo'),
    vuoto: t('hub.tavoli.vuoto'),
    inCorso: t('hub.tavoli.inCorso'),
    inAttesa: t('hub.tavoli.inAttesa'),
    riprendi: t('hub.tavoli.riprendi'),
    riprova: t('hub.tavoli.riprova'),
    guasto: { 'non-disponibile': t('hub.tavoli.guasto.non-disponibile'), rete: t('hub.tavoli.guasto.rete'), errore: t('hub.tavoli.guasto.errore') },
    nomeTavolo: (posti) => (posti === null ? t('titolo') : t('hub.tavoli.nomeTavolo', { n: posti })),
  };
  return <TavoliMiei useTavoli={usaTavoli} rottaTavolo={rottaTavolo} etichette={etichette} />;
}
